import React from 'react';

export function Stack({ children, style = {}, gap = 0, ...rest }) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: `${gap}px`,
                ...style,
            }}
            {...rest}
        >
            { children }
        </div>
    );
}
